import Layout from "../layouts/Layout";
import Home from "../pages/Home/Home";
import Intro from "../pages/Home/Intro";
import Opsaa from "../pages/Home/Opsaa";
import IniciativasRegionalesMain from "../pages/IniciativasHemisfericas/RegionalesMain";
import Iniciativas from "../pages/IniciativasWS/Iniciativas";
import ProgramasMain from "../pages/Programas/Main";

interface RouteProps {
  path: string;
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
}

export const routes: RouteProps[] = [
  {
    path: "/",
    component: Intro,
    layout: Layout,
  },
  {
    path: "/iica-numeros/:code?",
    component: Home,
    layout: Layout,
  },
  {
    path: "/opsaa",
    component: Opsaa,
    layout: Layout,
  },
  {
    path: "/iniciativas/:pageType",
    component: Iniciativas,
    layout: Layout,
  },
  {
    path: "/iniciativas/regionales",
    component: IniciativasRegionalesMain,
    layout: Layout,
  },
  /*----------------------------
    Programas
  ------------------------------*/
  {
    path: "/program/:code",
    component: ProgramasMain,
    layout: Layout,
  },
];
